import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function Card({ item }) {
  const rawTime = item[0];
  const eventTalk = item[1];
  const [time, setTime] = useState(dayjs(`${rawTime}`).format("HH:mm"));
  const [activeAbout, setActiveAbout] = useState(0);

  useEffect(() => {
    const rawTime = item[0];
    setTime(dayjs(`${rawTime}`).format("HH:mm"))
  }, [item]);

  function onChangeCountry(selectedTimeZone) {
    const defaultTimeZone = "Europe/Lisbon";

    const newTime = dayjs.tz(rawTime, defaultTimeZone).tz(selectedTimeZone).format("HH:mm");
    setTime(newTime);
  }

  function listenToTimeZoneChange() {
    const timeZoneSelector = document.querySelector('#timezone');
    timeZoneSelector.addEventListener('change', () => {
      onChangeCountry(timeZoneSelector.value);
    })
  }

  function handleClickAbout(postId) {
    if (activeAbout === postId) {
      setActiveAbout(0);
      return;
    }
    setActiveAbout(postId);
  }

  listenToTimeZoneChange();

  return (
    <li className="programming2020Container__main__body__content__item">
      <div className="programming2020Container__main__body__content__item__time">
        {time}
      </div>
      <ul>
        {
          eventTalk.map((event) => (
            <li key={event.post_id} className="programming2020Container__main__body__content__item__card">
              <div className="programming2020Container__main__body__content__item__card__info">
                <div className="programming2020Container__main__body__content__item__card__info__stage">
                  <div className="stage-color" style={`background: ${event.stages[0]?.color};`} />
                  {event.stages[0]?.name}
                </div>
                <div className="programming2020Container__main__body__content__item__card__info__language">
                  {
                    event.language
                    && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="grey"><path d="M444.373 359.424c0 7.168-6.144 10.24-13.312 13.312-28.672 12.288-59.392 23.552-92.16 23.552-46.08 0-67.584-28.672-122.88-28.672-39.936 0-81.92 14.336-115.712 29.696-2.048 1.024-4.096 1.024-6.144 2.048v77.824c0 21.405-16.122 34.816-33.792 34.816-19.456 0-34.816-15.36-34.816-34.816V102.4C12.245 92.16 3.029 75.776 3.029 57.344 3.029 25.6 28.629 0 60.373 0s57.344 25.6 57.344 57.344c0 18.432-8.192 34.816-22.528 45.056v31.744c4.124-1.374 58.768-28.672 114.688-28.672 65.27 0 97.676 27.648 126.976 27.648 38.912 0 81.92-27.648 92.16-27.648 8.192 0 15.36 6.144 15.36 13.312v240.64z" /></svg>
                  }
                  {event.language}
                </div>
                <div class="programming2020Container__main__body__content__item__card__info__duration">
                  {event.length && `Duração: ${event.length}`}
                </div>
              </div>

              <h2 className="programming2020Container__main__body__content__item__card__title" dangerouslySetInnerHTML={{ __html: event.title }} />

              <div class="programming2020Container__main__body__content__item__card__links">
                {
                  event.about
                  && <div>
                    <span class="programming2020Container__main__body__content__item__card__read-more" onClick={() => handleClickAbout(event.post_id)}>
                      Saiba mais sobre esse quadro [+]
                    </span>
                    {
                      activeAbout === event.post_id
                      && <p class="programming2020Container__main__body__content__item__card__about" dangerouslySetInnerHTML={{ __html: event.about }} />
                    }
                  </div>
                }
              </div>

              <div class="programming2020Container__main__body__content__item__card__links">
                {
                  event.links.map((link) => (
                    <a href={link.lecture_link} target="_blank" rel="noreferrer" class="programming2020Container__main__body__content__item__card__links__link">{link.lecture_link_title}</a>
                  ))
                }
              </div>

              <div className="programming2020Container__main__body__content__item__card__speakers">
                {
                  event.speakers.map((speaker) => (
                    <div key={speaker.id} className="programming2020Container__main__body__content__item__card__speakers__speaker">
                      <img className="programming2020Container__main__body__content__item__card__speakers__speaker__picture" src={speaker.thumbnail} loading="lazy" />
                      <span className="programming2020Container__main__body__content__item__card__speakers__speaker__name" dangerouslySetInnerHTML={{ __html: speaker.name }} />
                      <span className="programming2020Container__main__body__content__item__card__speakers__speaker__company" dangerouslySetInnerHTML={{ __html: speaker.company }} />
                    </div>
                  ))
                }
              </div>
              <div className="programming2020Container__main__body__content__item__card__speakers">
                {
                  event.mediators.map((mediator) => (
                    <div key={mediator.id} className="programming2020Container__main__body__content__item__card__speakers__speaker">
                      <img className="programming2020Container__main__body__content__item__card__speakers__speaker__picture" src={mediator.thumbnail} loading="lazy" />
                      <span className="programming2020Container__main__body__content__item__card__speakers__speaker__mediator">Moderador</span>
                      <span className="programming2020Container__main__body__content__item__card__speakers__speaker__name" dangerouslySetInnerHTML={{ __html: mediator.name }} />
                      <span className="programming2020Container__main__body__content__item__card__speakers__speaker__company" dangerouslySetInnerHTML={{ __html: mediator.company }} />
                    </div>
                  ))
                }
              </div>
              <div class="programming2020Container__main__body__content__item__card__tags">
                {
                  event.tags.map((tag) => (
                    <span class="programming2020Container__main__body__content__item__card__tags__tag">{tag}</span>
                  ))
                }
              </div>
            </li>
          ))
        }
      </ul>
    </li>
  )
}
